import { Directive, HostListener } from '@angular/core';

/**
 * En móvil, al enfocar un input hace scroll para que el teclado no lo tape.
 * Usar en `.auth-form` / contenedores OTP dentro de auth.
 */
@Directive({
  selector: '[authScrollOnFocus]',
  standalone: true,
})
export class AuthScrollOnFocusDirective {
  @HostListener('focusin', ['$event'])
  onFocusIn(event: FocusEvent): void {
    const target = event.target;
    if (!(target instanceof HTMLElement)) {
      return;
    }
    if (!target.matches('input, textarea, select, [contenteditable="true"]')) {
      return;
    }
    // Espera a que el teclado virtual redimensione el viewport.
    window.setTimeout(() => {
      try {
        target.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
      } catch {
        target.scrollIntoView(true);
      }
    }, 280);
  }
}
